<template>
  <div v-if="rouName == '超级管理员'">
    <el-row :gutter="24" style="margin-bottom: 20px">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>进件统计分析</span>
          </div>
          <div class="content" style="height: 240px">
            <div
              class="content-card"
              v-for="(item, index) in cardList"
              :style="{
                'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
              }"
              :key="index"
            >
              <div class="content-card-top">{{ item.content }}</div>
              <div class="content-card-title">{{ item.title }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>待办事项</span>
          </div>
          <div class="content" style="height: 240px">
            <div
              class="dealt-content"
              v-for="(item, index) in dealtList"
              :style="{
                'margin-right': index !== 1 || index !== 3 ? 10 + 'px' : '',
              }"
              :key="index"
              @click="toJump(item.path)"
            >
              <div>
                <div class="dealt-content-top">{{ item.title }}</div>
                <div class="dealt-content-bottom">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>基本信息</span>
          </div>
          <div style="height: 240px">
            <el-descriptions
              v-for="(item, index) in basicInfo"
              :key="index"
              :column="2"
              border
            >
              <el-descriptions-item
                :labelStyle="{
                  width: 100 + 'px',
                  background: 'none',
                  'border-bottom': index !== 3 ? 'none' : '',
                }"
                :contentStyle="{
                  height: index === 3 ? 80 + 'px' : '',
                  'border-bottom': index !== 3 ? 'none' : '',
                }"
                :label="item.title"
              >
                <div v-if="index !== 3">{{ item.content }}</div>
                <div v-else class="info-button" @click="toWeb">
                  {{ item.content }}
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" style="margin-top: 20px">
        <el-card>
          <div slot="header">
            <div style="display: flex; justify-content: space-between">
              <span>积分统计</span>
              <span style="color: #40a9ff; cursor: pointer" @click="toMoney"
                >点击查看图标明细</span
              >
            </div>
          </div>
          <div class="box" style="height: 240px">
            <div style="width: 50%;margin-left: 24px;">
              <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                  'marginBottom':24+'px'
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.sumMoney }}</div>
                <div class="content-card-title">平台总金额</div>
              </div>
              <div style="display: flex;">
                <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.cashMoney }}</div>
                <div class="content-card-title">已提现金额</div>
              </div>
              <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                  'margin-left':36+ 'px',
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.notCashMoney }}</div>
                <div class="content-card-title">提现未到账金额</div>
              </div>
              </div>

            </div>
            <div style="width: 1px; background: #001529;"></div>
            <div style="width: 50%;margin-left: 24px;">
              <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                  'marginBottom':24+'px'
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.sumIntegral }}</div>
                <div class="content-card-title">平台总发放积分</div>
              </div>
              <div style="display: flex;">
                <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.consumeIntegral }}</div>
                <div class="content-card-title">已使用积分</div>
              </div>
              <div
                class="content-card"
                :style="{
                  'margin-right': index !== 3 || index !== 7 ? 10 + 'px' : '',
                  'margin-left':36+ 'px',
                }"
                :key="index"
              >
                <div class="content-card-top">{{ moneyInfo.notIntegral }}</div>
                <div class="content-card-title">待使用积分</div>
              </div>
              </div>

            </div>
          </div>
        </el-card>
        <el-card style="margin-top: 20px">
          <div slot="header">
            <span>数据概览</span>
          </div>
          <div class="date-box">
            <div style="border-right: none" @click="tapTimeType(0)">年</div>
            <div style="border-right: none" @click="tapTimeType(1)">月</div>
            <div @click="tapTimeType(2)">本周</div>
          </div>
          <!-- erchar -->
          <div ref="analysis" style="height: 450px"></div>
        </el-card>
      </el-col>

      <el-col :span="8" style="margin-top: 20px">
        <el-card>
          <div slot="header">
            <span>操作日志</span>
          </div>
          <div>
            <el-table
              :data="options.tableData"
              style="width: 100%; overflow: auto; height: 440px"
            >
              <el-table-column
                prop="operName"
                label="用户"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="operatorType"
                label="类型"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{
                    ["其它 ", "新增", "修改", "删除"][scope.row.operatorType]
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="title" label="详情" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="operTime"
                label="时间"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="options.pageNo"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="100"
              layout="total, sizes, prev, pager, next"
              :total="options.total"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>
      <!-- <el-col :span="16" style="margin-top: 20px;"> -->
      <!-- <el-card>
          <div slot="header">
            <span>数据概览</span>
          </div>
          <div class="date-box">
            <div style="border-right: none" @click="tapTimeType(0)">年</div>
            <div style="border-right: none" @click="tapTimeType(1)">月</div>
            <div @click="tapTimeType(2)">本周</div>
          </div> -->
      <!-- erchar -->
      <!-- <div ref="analysis" style="height: 450px;"></div> -->
      <!-- </el-card> -->
      <!-- </el-col> -->
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      rouName: "",
      //资金积分概览
      moneyInfo: {},
      // 数据总览
      cardList: [
        {
          title: "用户数",
          content: "",
        },
        {
          title: "商品数量",
          content: "",
        },
        {
          title: "服务订单数",
          content: "",
        },
        {
          title: "商品订单数",
          content: "",
        },
        {
          title: "商户数",
          content: "",
        },
        {
          title: "申请服务数",
          content: "",
        },
        {
          title: "提现数",
          content: "",
        },
      ],
      // 待办事项
      dealtList: [
        {
          title: "待审核商户",
          content: "",
          path: "/merchant/businessListings",
        },
        {
          title: "待提现",
          content: "",
          path: "/finance/withdrawal",
        },
        {
          title: "待发货",
          content: "",
          path: "/orderManagement/productOrder",
        },
        {
          title: "待售后",
          content: "",
          path: "/orderManagement/afterSale",
        },
      ],
      // 基本信息
      basicInfo: [
        {
          title: "账号",
          content: "",
        },
        {
          title: "昵称",
          content: "",
        },
        {
          title: "角色",
          content: "",
        },
        {
          title: "网站",
          content: "网站首页",
        },
      ],
      //页面参数
      options: {
        // 页码
        pageNo: 1,
        // 每页数量
        pageSize: 10,
        // 数量
        total: 0,
        // 表格信息
        tableData: [],
        // 用户名
        name: "",
        // 角色权限
        userList: [],
      },
      // ercharsX轴
      XData: [],
      // Y轴数据
      YData: [],
      // 时间类型
      dateType: "",
      // 当前日期时间
      nowDate: "",
    };
  },

  mounted() {
    this.name = localStorage.getItem("name");
    this.rouName = localStorage.getItem("rouName");
    console.log(this.name, "this.name1111");
    let that = this;
    if (localStorage.getItem("name") !== "admin") {
      that.$router.push("/account/app");
    }
    this.tapTimeType(2);
    this.getList();
  },
  computed: {
    ...mapState(["route"]),
  },
  watch: {
    route() {
      this.getList();
    },
  },
  methods: {
    toMoney() {
      this.$router.push({ path: "/board/money" });
    },
    /**
     * 跳转外部网页
     */
    toWeb() {
      window.open("http://www.aiteyixia.cn/", "_blank");
    },
    /**
     * 数据概览
     */
    drawline() {
      var myChart = this.$echarts.init(this.$refs["analysis"]);
      let option = {
        // 顶部
        legend: {
          data: ["用户", "商户", "商品订单", "服务订单"],
        },
        // 布局
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.XData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "用户",
            type: "line",
            // stack: 'Total',
            data: this.YData.users,
          },
          {
            name: "商户",
            type: "line",
            data: this.YData.business,
          },
          {
            name: "商品订单",
            type: "line",
            data: this.YData.goods,
          },
          {
            name: "服务订单",
            type: "line",
            data: this.YData.service,
          },
        ],
      };
      myChart.setOption(option);
    },
    /**
     * 获取列表
     */
    getList() {
      // 获取统计信息
      this.getHomeInfoStatistics();
      // 获取待办事项信息
      this.getDealtList();
      // 获取角色信息
      this.getHomeUserInfo();
      // 获取数据概念
      this.getHomeGeneralView();
      // 获取操作日志
      this.getJournal();
      // 获取资金积分概览
      this.getMoneyIntegral();
    },
    /**
     * 资金积分概览
     */
    getMoneyIntegral() {
      this.$api.Login.moneyIntegral().then((res) => {
        let data = res.data.data;
        this.moneyInfo = data;
      });
    },
    /**
     * 统计信息
     */
    getHomeInfoStatistics() {
      this.$api.Login.homeInfoStatistics().then((res) => {
        let data = res.data.data;
        this.cardList.map((e, index) => {
          switch (index) {
            case 0:
              e.content = data.usersSum;
              break;
            case 1:
              e.content = data.categoryInfoSum;
              break;
            case 2:
              e.content = data.serviceOrderSum;
              break;
            case 3:
              e.content = data.orderInfoSum;
              break;
            case 4:
              e.content = data.businessInfoSum;
              break;
            case 5:
              e.content = data.applyServiceOrderSum;
              break;
            case 6:
              e.content = data.cashSum;
              break;
          }
          return;
        });
      });
    },
    /**
     * 获取待办事项信息
     */
    getDealtList() {
      this.$api.Login.homeDealt().then((res) => {
        let data = res.data.data;
        this.dealtList.map((e, index) => {
          switch (index) {
            case 0:
              e.content = data.businessInfoSum;
              break;
            case 1:
              e.content = data.cashSum;
              break;
            case 2:
              e.content = data.orderInfoSum;
              break;
            case 3:
              e.content = data.afterSaleSum;
              break;
          }
          return;
        });
      });
    },
    /**
     * 获取数据概念
     */
    getHomeGeneralView() {
      let params = {
        // 统计范围：0：年 1：月 2：周
        type: this.dateType,
      };
      this.$api.Login.homeGeneralView(params).then((res) => {
        let data = res.data.data;
        this.YData = data;
        this.drawline();
      });
    },
    /**
     * 获取角色信息
     */
    getHomeUserInfo() {
      let data = this.$store.state.route;
      this.basicInfo.forEach((e, index) => {
        switch (index) {
          case 0:
            e.content = data.userName;
            break;
          case 1:
            e.content = data.nickName;
            break;
          case 2:
            e.content = data.roleContent;
            break;
        }
      });
    },
    /**
     * 获取操作日志
     */
    getJournal() {
      let params = {
        pageNo: this.options.pageNo,
        pageSize: this.options.pageSize,
      };
      this.$api.Login.homeJournal(params).then((res) => {
        res.data.data.list.forEach((e) => {
          e.operTime = this.moment(e.operTime).format("YYYY-MM-DD");
        });
        this.options.tableData = res.data.data.list;
        this.options.total = res.data.data.total;
      });
    },
    /**
     * 时间类型跳转
     */
    tapTimeType(e) {
      this.dateType = e;
      let dateList = [];
      var date = new Date();
      // 0.年 1.月 2.本周
      if (e === 0) {
        let year = date.getFullYear();
        for (let i = 0; i < 5; i++) {
          dateList.push(year - i);
        }
        dateList.sort((oldVal, newVal) => {
          return oldVal - newVal;
        });
        this.XData = dateList;
      } else if (e === 1) {
        let month = date.getMonth() + 1;
        for (let i = 0; i < month; i++) {
          dateList.push(month - i);
        }
        dateList.sort((oldVal, newVal) => {
          return oldVal - newVal;
        });
        let arr = dateList.map((e) => {
          e = e + "月";
          return e;
        });
        this.XData = arr;
      } else {
        this.XData = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      }
      this.getHomeGeneralView();
    },
    /**
     * 调整每天条数
     */
    handleSizeChange(val) {
      this.options.pageSize = val;
      this.getJournal();
    },
    /**
     * 当前页
     */
    handleCurrentChange(val) {
      this.options.pageNo = val;
      this.getJournal();
    },
    /**
     * 跳转
     */
    toJump(e) {
      this.$router.push({ path: e });
    },
  },
};
</script>

<style scoped>
.box{
  display: flex;
  justify-content: space-between;

}
.content {
  display: flex;
  flex-wrap: wrap;
}

.content-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(25% - 10px);
  /* padding: 5px; */
}

.content-card-top {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
  height: 60px;
  width: 100%;
  border-radius: 2px;
  color: #333;
  font-size: 21px;
}

.content-card-title {
  margin-top: 5px;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  color: #666;
}

.dealt-content {
  width: calc(50% - 10px);
  height: calc(50% - 10px);
  box-sizing: border-box;
  padding: 0 15px;
  background: #f8f8f8;
  cursor: pointer;
}

.dealt-content-top {
  padding: 15px 0;
  font-size: 16px;
  color: #999;
}

.dealt-content-bottom {
  font-style: normal;
  font-size: 30px;
  font-weight: 700;
  color: #009688;
}

.info-button {
  cursor: pointer;
  background: #009688;
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  color: #fff;
  display: inline-block;
  border-radius: 2px;
}

.date-box {
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #f6f6f6;
  padding-bottom: 10px;
}

.date-box > div {
  border: 1px solid #c9c9c9;
  box-sizing: border-box;
  padding: 0 5px;
  font-size: 12px;
  cursor: pointer;
}

.date-box > div:hover {
  color: #009688;
}

.pagination {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue